<template>
  <div class="box15">
    <pageTitle title="常见问题" titleColor="#0D004D" />

    <commomProblem :problemData="problemData" :styleData="styleData" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "想做抖音，不知道拍什么好？",
          answer: [
            "报名课程之后会有专业运营老师一对一指导咱们去做账号定位，做内容分类。",
          ],
        },
        {
          title: "拍了几个作品，一直不涨粉怎么办？",
          answer: [
            "这个问题需要专业老师针对性的分析一下咱们的账号问题，然后根据具体问题去进行内容调整优化。优化后的账号会实现快速涨粉的哦~",
          ],
        },
        {
          title: "可以先试学一下么？",
          answer: ["咱们第一章节开通了试学课程，可以先试学，满意再报名~"],
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/media/box15/icon.png"),
      },
    };
  },
  methods: {
    zixun(name) {
      zhuge.track("H5_人工智能专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
.box15 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/media/box15/bgc.png") no-repeat;
  background-size: cover;
  /deep/ .question {
    width: 35px;
    height: 34px;
  }
}
</style>
